/** @module modules/app/controls */
export * from './OrbitControlsModule';
